import { render, staticRenderFns } from "./WrapperFromGroupPricingAndDosesDistribution.vue?vue&type=template&id=568164a9&"
import script from "./WrapperFromGroupPricingAndDosesDistribution.vue?vue&type=script&lang=js&"
export * from "./WrapperFromGroupPricingAndDosesDistribution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports